import type { Styles } from '@adornis/ass/style.js';
import '@adornis/chemistry/elements/components/x-flex';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { DlaFooterPage } from './dla-footer-page.js';

/*
 * @element dla-imprint
 */
@customElement('dla-imprint')
export class DlaImprint extends DlaFooterPage {
  override render() {
    return html`
      <x-flex class="container" space="xl">
        ${this.backButton()}

        <x-flex space="md">
          <x-h1> Impressum </x-h1>
          <x-text> Angaben gem. § 5 TMG. </x-text>
        </x-flex>
        <x-flex space="md">
          <x-text> Goethe-Universität Frankfurt am Main </x-text>
          <x-text> Theodor-W.-Adorno-Platz 1 </x-text>
          <x-text> 60323 Frankfurt am Main </x-text>
        </x-flex>
        <x-flex space="md">
          <x-text> Telefon: +49 (0) 69 / 798-0 </x-text>
          <x-text> Telefax: +49 (0) 69 / 798-18383 </x-text>
          <x-text> Email: praesident@uni-frankfurt.de </x-text>
          <x-text> Internet: http://www.uni-frankfurt.de </x-text>
        </x-flex>
        <x-text> Die Goethe-Universität Frankfurt am Main ist eine Stiftung des öffentlichen Rechts. </x-text>
        <x-flex space="md">
          <x-text> Gesetzlicher Vertreter: </x-text>
          <x-text> Prof. Dr. Enrico Schleiff </x-text>
          <x-text> Zuständige Aufsichtsbehörde: </x-text>
          <x-text> Hessisches Ministerium für Wissenschaft und Kunst </x-text>
          <x-text> Rheinstr. 23-25 </x-text>
          <x-text> 65185 Wiesbaden </x-text>
          <x-text> Tel: +49 (0) 611 / 32-0 </x-text>
          <x-text> Umsatzusteuer-Identifikationsnummer gem. § 27a Umsatzusteuergesetz: </x-text>
          <x-text> DE 114110511 </x-text>
        </x-flex>
        <x-flex space="md">
          <x-text> studiumdigitale </x-text>
          <x-text> Goethe-Universität Frankfurt am Main </x-text>
          <x-text> Zentrale eLearning-Einrichtung </x-text>
          <x-text> Eschersheimer Landstr. 155/157 </x-text>
          <x-text> 60323 Frankfurt am Main </x-text>
          <x-text> Telefon: +49 (0) 69 / 798-22198 </x-text>
          <x-text> Telefax: +49 (0) 69 / 798-22195 </x-text>
          <x-text> Email: info@studiumdigitale.uni-frankfurt.de </x-text>
          <x-text> Internet: www.studiumdigitale.uni-frankfurt.de </x-text>
          <x-text> Vertreter: </x-text>
          <x-text> Prof. Dr. Hendrik Drachsler (Wissenschaftliche Leitung) </x-text>
          <x-text> Prof. Dr. Alexander Tillmann (Geschäftsführung) </x-text>
        </x-flex>
      </x-flex>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          overflowY: 'auto',
        },
        '.container': {
          width: '100%',
          maxWidth: this.sizes.maxReadableWidth,
          margin: '0 auto',
          paddingTop: this.spacing.lg,
          paddingBottom: this.spacing.xl,
        },
      } as Styles,
    ];
  }
}
